// verbose / log / warn / error BELOW ARE DELIBERATE OVERRIDES of framework
// element methods, and they are the ONLY names in this library's `methods` bag
// that may be (WS-SHARED-METHODS-SHADOW-FRAMEWORK-ELEMENT-METHODS-1, Rule 63 —
// an intentional override is documented, never accidental; ./root.js carries the
// matching note for the seven names withheld there).
//
// WHY THEY WIN, and are allowed to: mergeSharedLibraries copies this bag into the
// consuming app's `context.methods`, which @symbo.ls/element layers OVER its
// built-in element methods, so each of these four replaces the built-in on every
// element of every consuming app. The framework sanctions exactly these four as
// OVERRIDE POINTS (@symbo.ls/utils keys.js ELEMENT_METHOD_OVERRIDE_POINTS, smbls
// 1ad078784): they are observability channels, not element semantics — the
// element's own tree, state and rendering never depend on what they do.
//
// WHY THE WORKSPACE NEEDS ITS OWN: about 90 call sites here rely on
// log-and-continue in EVERY environment (`return this.error('…')` is an early
// exit that must not become an exception). The built-ins differ on all four —
// built-in error() THROWS in test/development and is silent in production,
// built-in log(...keys) prints a `{ key: el[key] }` debug map rather than the
// caller's message, and built-in warn/verbose print only in test/development.
// Taking the built-ins would make every dev build throw on this.error(...).
//
// KNOWN DEAD BRANCH, kept deliberately un-removed here: the OTEL span path in
// warn/error is gated on `window.symbols.faro`, and NOTHING sets it any more —
// the shell replaced Faro with @symbo.ls/analyzing
// (packages/workspace/analyzing.js) and the SDK sets `window.symbols.tracking`,
// not `.faro`. So both functions always take the plain console branch today. It
// is inert rather than wrong, and deleting a tracing hook is a separate call from
// un-shadowing a method, so it stays until someone decides where these two should
// report; do not read its presence as evidence that Faro is wired.
//
// Locked by packages/workspace/__tests__/sharedLibraryMethodsDoNotShadowBuiltins.test.js,
// which fails if a fifth built-in name appears in any library methods bag.

export function groupLog(...params) {
  // if (isNotProduction()) {
  console.group(...params)
  // }
}

export function groupLogEnd(...params) {
  // if (isNotProduction()) {
  console.groupEnd(...params)
  // }
}

export function verbose(element, ...args) {
  // if (isProduction()) return

  const parent = this
  const { __ref: ref } = parent
  console.groupCollapsed(parent.key)
  if (args.length) {
    args.forEach((v) => console.log(`%c${v}:\n`, 'font-weight: bold', parent[v]))
  } else {
    console.log(ref.path)
    const keys = parent.keys()
    keys.forEach((v) => console.log(`%c${v}:`, 'font-weight: bold', parent[v]))
  }
  console.log(parent)
  console.groupEnd(parent.key)
  return parent
}

export function log(...params) {
  // if (isProduction()) return
  console.log(...params)
}

export function warn(...params) {
  // if (isProduction()) return
  const { hostname } = window.location
  if (!hostname || hostname === 'localhost' || typeof window.symbols?.faro === 'undefined') {
    return console.warn(...params, this)
  }
  const { trace, context } = window.symbols.faro.api.getOTEL()
  const tracer = trace.getTracer('frontend-uikit-tracer')
  const span = tracer.startSpan('warning')
  context.with(trace.setSpan(context.active(), span), () => {
    console.warn(...params, this)
    span.end()
  })
}

export function error(...params) {
  // if (isProduction()) return
  const logger = () => {
    const lastParam = params[params.length - 1]
    const hasOpts = typeof lastParam === 'object' && lastParam
    if (hasOpts?.debugger) debugger
    if (hasOpts?.verbose) {
      this.verbose.call(this, ...params)
    }
    if (this.call('isFunction', hasOpts?.onError)) {
      hasOpts?.onError.call(this, ...params)
    }
    console.error(...params, this)
  }
  const { hostname } = window.location
  if (!hostname || hostname === 'localhost' || typeof window.symbols?.faro === 'undefined') {
    return logger()
  }
  const { trace, context } = window.symbols.faro.api.getOTEL()
  const tracer = trace.getTracer('frontend-uikit-tracer')
  const span = tracer.startSpan('error')
  context.with(trace.setSpan(context.active(), span), () => {
    logger()
    span.end()
  })
}
